import { useSelector } from "react-redux";
import { AddCommas, DateFormat, DownloadByContent, TreeManagementValue, decodeHtmlEntities, mimeTypes } from "../utils";
import { LanguageLoader } from "../../assets/languages";
import Attachment from "./Attachment";
import { Link } from "react-router-dom";
import FieldContainer from "./FieldContainer";
import { useEffect } from "react";
import { DownloadFileAPI } from "../../services";
import HTMLCode from "./HTMLCode";
import Linkable from "./Linkable";

const FormatValue = ({value, vardef, format, related_to}) =>
{
	value = decodeHtmlEntities(value);
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	useEffect(() =>
	{
		if(vardef.type === 'text')
		{
			document.querySelectorAll('.HTML_code a').forEach(element =>
			{
				element.addEventListener('click', function(event)
				{
					event.preventDefault();
					const fileID = element.href.split('entryPoint=download&id=')[1];
					DownloadFileAPI(fileID).then(response =>
					{
						if(response && response.content)
						{
							DownloadByContent(response.content, response.name);
						}
					});
				});
			});
			document.querySelectorAll('.HTML_code img').forEach(element =>
			{
				const SRC = element.getAttribute('src');
				if(SRC.indexOf('entryPoint=download&id=') !== -1 && SRC.indexOf('&utype=') === -1)
				{
					const fileID = SRC.split('entryPoint=download&id=')[1];
					DownloadFileAPI(fileID).then(APIResponse =>
					{
						let extension = '';
						if(APIResponse.extension)
						{
							extension = APIResponse.extension;
						}
						else if(APIResponse.name && APIResponse.name.indexOf('.') > -1)
						{
							extension = APIResponse.name.split('.').slice(-1)[0];
						}
						const mime = mimeTypes[extension];
						let fileSRC = '';
						if(typeof mime !== 'undefined' && mime.indexOf('image') > -1)
						{
							fileSRC = 'data:'+mime+';base64,'+APIResponse.content;
						}
						element.style.maxHeight = '100px';
						element.style.borderRadius = '8px';
						element.style.cursor = 'pointer';
						element.src = fileSRC;
						element.addEventListener('click', function()
						{
							DownloadFileAPI(fileID).then(response =>
							{
								if(response && response.content)
								{
									DownloadByContent(response.content, response.name);
								}
							});
						});
					});
				}
			});
		}
	// eslint-disable-next-line
	}, [value]);

	if(vardef)
	{
		if(vardef.type === 'date' || vardef.type === 'datetime')
		{
			const dates = settings.dropdowns.dates;
			value = dates.hasOwnProperty(value) ? dates[value] : DateFormat(value, format);
		}
		else if(vardef.type === 'enum' && vardef.options)
		{
			value = vardef.options[value];
		}
		else if(vardef.type === 'multienum' && vardef.options)
		{
			let selectedValue = '';
			if(value && value.length)
			{
				for(const item of value)
				{
					if(selectedValue !== '')
					{
						selectedValue += ', ';
					}
					// Check if item is a key (exists in options) or already a label
					if(vardef.options[item] !== undefined)
					{
						selectedValue += vardef.options[item];
					}
					else
					{
						selectedValue += item;
					}
				}
				value = selectedValue;
			}
		}
		else if(vardef.type === 'bool')
		{
			value = <div className="form-check form-switch">
				<input className="form-check-input" type="checkbox" disabled={true}/>
			</div>;
		}
		else if(vardef.type === 'relate')
		{
			if(vardef.module !== '' && settings.definitions.modules[vardef.module])
			{
				value = <Link to={'/detail/'+vardef.module+'/'+value} className="hover:text-primary">{related_to}</Link>;
			}
			else
			{
				value = related_to;
			}
		}
		else if(vardef.type === 'tree')
		{
			if(value && vardef.options)
			{
				value = TreeManagementValue(vardef.options, value);
			}
		}
		else if(vardef.type === 'numbers')
		{
			if(Array.isArray(value) && value.length)
			{
				if(value)
				{
					value = value.map((data, index) => {
						return <div key={index} className='mt-1'>
							<a href={'tel:'+data.country_code+data.number} className='inline-block' style={{direction: 'ltr'}}>{data.country_code+data.number}</a>
							{data.type === 'Mobile' ? <span className='mx-3 bg-info text-secondaryFont p-1 rounded text-xs'>شماره همراه</span> : null}
						</div>;
					});
				}
			}
		}
		else if(vardef.type === 'emails')
		{
			if(value && value.length)
			{
				value = value.map((data, index) => {
					return <div key={index} className='mt-1'>
						<a href={'mailto:'+data.email_address} className='inline-block' style={{direction: 'ltr'}}>{data.email_address}</a>
						{data.primary_address ? <span className='mx-3 bg-info text-secondaryFont p-1 rounded text-xs'>اصلی</span> : null}
					</div>;
				});
			}
		}
		else if(vardef.type === 'attachments')
		{
			if(value && value.length)
			{
				value = value.map((file, index) => <Attachment key={index} fileKey={index} types={vardef.options} info={file} editable={false}/>);
			}
		}
		else if(vardef.type === 'addresses')
		{
			if(Array.isArray(value) && value.length)
			{
				if(value)
				{
					value = value.filter((address) => address.street.length || address.city.length).map((address, index) => 
						<div key={index} className='flex items-center justify-between mb-2 last:mb-0'>
							<span className='inline-block w-[70%] overflow-hidden text-ellipsis lg:whitespace-nowrap text-sm'>{[address.city, address.street].join(', ')}</span>
							<span>
								{address.billing ? <span className='bg-info text-white px-1 py-1 rounded text-xs mx-1'>{language.FIELDS.BILLING}</span> : null}
								{address.shipping ? <span className='bg-info text-white px-1 py-1 rounded text-xs mx-1'>{language.FIELDS.SHIPPING}</span> : null}
							</span>
						</div>
					);
				}
			}
		}
		else if(vardef.type === 'lineitems')
		{
			let rows;
			const hiddenOnMobile = ['PRODUCT_NAME', 'PRODUCT_QTY', 'TOTAL_PRICE'];
			const textColumns = ['NAME', 'PRODUCT_NAME','PART_NUMBER', 'DESCRIPTION', 'ITEM_DESCRIPTION'];
			const amountColumns = ['PRODUCT_LIST_PRICE', 'VAT_AMT', 'DISCOUNT_AMOUNT'];
			const columns = settings.lineitem && settings.lineitem.columns ? settings.lineitem.columns : [];
			let totalPrice = 0;
			let totalVat = 0;
			let totalDiscount = 0;

			if(value && value.length)
			{
				rows = value.map((row, index) => <tr key={index}>
					{columns.map(field =>
					{
						let tempValue = AddCommas(row[field]);
						if(textColumns.includes(field.toUpperCase()))
						{
							tempValue = row[field];
						}
						else if(row.currency_symbol && amountColumns.includes(field.toUpperCase()))
						{
							tempValue += ' '+row.currency_symbol;
						}
						return <td key={field} className={hiddenOnMobile.includes(field.toUpperCase()) ? '' : 'hidden md:table-cell'}>{tempValue}</td>
					})}
				</tr>);
				
				for (const item of value)
				{
					if(!item.deleted && item.product_list_price && item.product_qty)
					{
						let grandTotal = item.product_list_price * item.product_qty;
						if(item.vat_amt)
						{
							grandTotal = parseFloat(grandTotal) + parseFloat(item.vat_amt);
						}
						if(item.discount_amount)
						{
							grandTotal = parseFloat(grandTotal) - parseFloat(item.discount_amount);
						}
						totalPrice += grandTotal;
						totalVat += parseFloat(item.vat_amt);
						totalDiscount += parseFloat(item.discount_amount);
					}
				}
			}
			value = <div>
				<div className='grow flex gap-10 text-sm overflow-auto'>
				<table>
					<thead>
					<tr>
						{columns.map((field, index) => <th key={index} className={hiddenOnMobile.includes(field.toUpperCase()) ? '' : 'hidden md:table-cell'}>{language.FIELDS[field.toUpperCase()]}</th> )}
					</tr>
					</thead>
					<tbody>{rows && rows.length ? rows : null}</tbody>
				</table>
			</div>
			<div className="flex">
				<FieldContainer label={language.FIELDS.DISCOUNT} className='mt-3 mb-0'>
					<div className='value'>{AddCommas(totalDiscount)}</div>
				</FieldContainer>
				<FieldContainer label={language.FIELDS.TAX} className='mt-3 mb-0'>
					<div className='value'>{AddCommas(totalVat)}{value && value[0] && value[0].currency_symbol ? ' '+value[0].currency_symbol : null}</div>
				</FieldContainer>
			</div>
			<div className="flex">
				<FieldContainer label={language.FIELDS.GRAND_TOTAL} className='mt-3 mb-0'>
					<div className='value'>{AddCommas(totalPrice)}{value && value[0] && value[0].currency_symbol ? ' '+value[0].currency_symbol : null}</div>
				</FieldContainer>
				<FieldContainer label={language.FIELDS.TOTAL_QTY} className='mt-3 mb-0'>
					<div className='value'>{value ? AddCommas(value.filter(item => !item.deleted || item.deleted === 0).reduce((sum, item) => Number(sum) + Number(item.product_qty), 0)) : 0}</div>
				</FieldContainer>
			</div>
		</div>;
		}
		else if(vardef.type === 'currency' || vardef.type === 'int')
		{
			value = (value && value !== '') ? AddCommas(Number(value)) : '';
		}
		else if(vardef.type === 'text')
		{
			if(value)
			{
				value = <HTMLCode innerHtml={value}/>
			}
		}
		else if(vardef.type === 'linkable')
		{
			if(value)
			{
				value = <Linkable field={vardef.name} value={value}/>
			}
		}
	}
	return value;
}

export default FormatValue;